import { connect } from 'react-redux';
import ParticipantList from './ParticipantsList';
import {
  fetchClassRoomParticipants,
  removeUserFromSpace,
} from '../../../../../core/actions/classRoom/participants';
import {
  currentClassRoomId,
  participants,
} from '../../../../../core/selectors/classroom';
import { createAndSelectConversation } from '../../../../actions/inboxv2';

const mapStateToProps = (state, props) => {
  const spaceId = currentClassRoomId(state);
  if (spaceId) {
    return {
      users: participants(state, spaceId),
      isFetching: state.classRoom.isFetchingParticipants,
      hasFetchedAll: state.classRoom.hasFetchedAllParticipants,
      filtered: !!props.filter,
    };
  }
  return {
    users: [],
    isFetching: true,
    hasFetchedAll: false,
  };
};

const mapDispatchToProps = (dispatch) => ({
  fetchParticipants: ({ skip, sort }) =>
    dispatch(fetchClassRoomParticipants({ skip, sort })),
  onMessage: (user) => dispatch(createAndSelectConversation(user)),
  removeUserFromSpace: (userId) => dispatch(removeUserFromSpace(userId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ParticipantList);
